//DragItem.js

import React from 'react';
import { useDrag } from 'react-dnd';
import QmModuleStyle from "../../styles/qm.module.css";

const DragItem = ({defaultDragObj,onClick,isSelected,onkeyup }) => {
    //debugger;
    let id=defaultDragObj.id;
    let title=defaultDragObj.title;
    let dropid=defaultDragObj.dropid;
    const handleClick = (id,e) => {
        e.stopPropagation();
        if (onClick) {
            onClick(id,e);
        }
    };
    const handleKeyUp =(id,e)=>{
        //debugger;
        e.stopPropagation();
        if (e.key === 'Enter' || e.charCode === 13 || e.charCode === 13) {
            if(onkeyup){
                onkeyup(id,e);
            }
            //console.log('do validate')
        }
    }
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'item',
        item: { defaultDragObj },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    return (
        <div
            ref={drag}
            className={`${QmModuleStyle["dragItem"]}  ${isSelected ? QmModuleStyle["selected"] : ''}`}
            style={{
                opacity: isDragging ? 0.5 : 1,
            }} aria-pressed={`${isSelected ? true : false}`} role="button" id={defaultDragObj.id} onClick={(e)=>{ handleClick(defaultDragObj.id,e)}} onKeyUp={(e)=>{ handleKeyUp(defaultDragObj.id,e)}} tabIndex={0}>
            {defaultDragObj.title}
        </div>
    );
};

export default DragItem;